"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "knockAnswered", {
  enumerable: true,
  get: function get() {
    return _knockAnswered["default"];
  }
});
var _knockAnswered = _interopRequireDefault(require("./knockAnswered"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }